import { ChangeDetectorRef, EventEmitter, Injector, Input, Output, Directive } from '@angular/core';
import { ITask } from '@fi-shared/fi-task-shared/fi-task-shared';
import { AppTextService } from '@fi-shared/app-text';
import { FiTaskHelperService } from '@fi-shared/fi-task-shared/fi-task-helper.service';
import { LoadingService } from '@fi-shared/fi-loading/loading.service';
import { FiTaskSharedService } from '@fi-shared/fi-task-shared/fi-task-shared.service';
import { FiUserDataService } from '@fi-shared/fi-shared-services/fi-user-data.service';

@Directive()
export class TasksStatusCardBase {
    @Input() tasks: ITask[];
    @Output() taskPropertyChanged = new EventEmitter<void>();
    @Output() tasksDeleted = new EventEmitter<ITask[]>();

    protected appTextService: AppTextService;
    protected taskHelperService: FiTaskHelperService;
    private loadingService: LoadingService;
    private taskService: FiTaskSharedService;
    private userDataService: FiUserDataService;

    constructor(private injector: Injector) {
        this.appTextService = injector.get(AppTextService);
        this.taskHelperService = injector.get(FiTaskHelperService);
        this.loadingService = injector.get(LoadingService);
        this.taskService = injector.get(FiTaskSharedService);
        this.userDataService = injector.get(FiUserDataService);
    }

    selectedTasks: ITask[] = [];
    get selectedTaskIds() {
        return this.selectedTasks.map((task) => task.Id);
    }

    taskActionItems: {
        onClick: () => void;
        title: string;
    }[];

    isActionDisabled() {
        return !this.selectedTasks.length;
    }

    protected saveTaskCompleted(isCompleted) {
        this.taskService.saveTaskCompleted(
            this.selectedTasks,
            isCompleted,
            () => {
                this.selectedTasks = [];
                this.taskPropertyChanged.emit();
            },
            () => {},
        );
    }

    protected saveTaskArchived(isArchived: boolean) {
        return this.loadingService
            .trackPromise(this.taskService.saveTaskArchived(this.selectedTasks, isArchived))
            .then(() => {
                this.selectedTasks = [];
                this.taskPropertyChanged.emit();
            });
    }

    protected deleteTasks() {
        return this.loadingService.trackPromise(this.taskService.deleteTasks(this.selectedTaskIds)).then(() => {
            this.tasksDeleted.emit(this.selectedTasks);
            this.selectedTasks = [];
            this.injector.get(ChangeDetectorRef).markForCheck();
        });
    }

    protected sendTaskReminders() {
        return this.loadingService.trackPromise(this.taskService.sendTaskReminders(this.selectedTaskIds)).then(() => {
            this.selectedTasks.forEach((task) => (task.LastReminderSent = new Date().toISOString()));
            this.selectedTasks = [];
            this.injector.get(ChangeDetectorRef).markForCheck();
        });
    }
}
